/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { call, put, takeLatest } from 'redux-saga/effects';
import request from 'modules/common/utils/request';
import { trendActions } from 'modules/dashboard/components/tab-container/trend-tabs/slice';
import API from 'modules/dashboard/components/tab-container/trend-tabs/constants';
import { API as ORGANIZATION_API } from 'modules/dashboard/constants';
/**
 * Save segment filter generator function to save segment filter combination
 * @param {*} param0
 */
export function* saveSegmentFilterGenerator({ payload }) {
  try {
    const response = yield call(request, API.POST_SEGMENT_FILTER, payload);
    yield put(trendActions.saveSegmentFilterSucceeded(response));
  } catch (error) {
    yield put(trendActions.saveSegmentFilterFailed(error?.message));
  }
}
/**
 * validate filter name generator function to check filter name already exist or not
 * @param {*} param0
 */
export function* validateFilterNameGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_SEGMENT_FILTER, payload);
    yield put(trendActions.getFilterNameValidationSucceeded(response));
  } catch (error) {
    yield put(trendActions.getFilterNameValidationFailed(error?.message));
  }
}
/**
 * Get aggregation filter generator function to obtain saved aggregation filter combination
 * @param {*} param0
 */
export function* getAggregationFilterGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_SEGMENT_FILTER, payload);
    yield put(trendActions.getAggregationFilterSucceeded(response));
  } catch (error) {
    yield put(trendActions.getAggregationFilterFailed(error?.message));
  }
}

/**
 * Delete aggregation filter generator function to obtain saved aggregation filter combination
 * @param {*} param0
 */
export function* deleteAggregationFilterGenerator({ payload }) {
  try {
    const response = yield call(request, API.DELETE_SEGMENT_FILTER, payload);
    yield put(
      trendActions.deleteAggregationFilterSucceeded({
        response,
        data: payload,
      })
    );
  } catch (error) {
    yield put(trendActions.deleteAggregationFilterFailed(error?.message));
  }
}
/**
 * Get trend data generator function to get organization related data
 * @param {*} param0
 */
export function* getTrendDataGenerator({ payload }) {
  try {
    const response = yield call(request, ORGANIZATION_API.GET_JS_VISUAL_DATA, payload);
    yield put(trendActions.getTrendDataSucceeded(response));
  } catch (error) {
    yield put(trendActions.getTrendDataFailed(error?.message));
  }
}
//
export function* trendSaga() {
  yield takeLatest(trendActions.saveSegmentFilter.type, saveSegmentFilterGenerator);
  yield takeLatest(trendActions.getFilterNameValidation.type, validateFilterNameGenerator);
  yield takeLatest(trendActions.getAggregationFilter.type, getAggregationFilterGenerator);
  yield takeLatest(trendActions.deleteAggregationFilter.type, deleteAggregationFilterGenerator);
  yield takeLatest(trendActions.getTrendData.type, getTrendDataGenerator);
}
//
export default trendSaga;
